import {CalendarWorkdayInvitationListProps} from './types';

import {useAppSelector} from '@hooks';
import {getIsGroupWorkspaceReservationEnabled, getPendingWorkspaceReservationsByDate} from '@lib/store';
import {parseISO} from 'date-fns';
import {CalendarWorkdayInvitationCell} from '@organisms';

export const CalendarWorkdayInvitationList = ({
  date,
  color = 'energizingYellow',
}: CalendarWorkdayInvitationListProps) => {
  const isGroupWorkspaceReservationFeatureEnabled = useAppSelector(getIsGroupWorkspaceReservationEnabled);
  const pendingWorkspaceReservations = useAppSelector((state) =>
    getPendingWorkspaceReservationsByDate(state, parseISO(date)),
  );

  return (
    <>
      {isGroupWorkspaceReservationFeatureEnabled &&
        !!pendingWorkspaceReservations?.length &&
        pendingWorkspaceReservations.map((workspace) => (
          <CalendarWorkdayInvitationCell
            {...{
              workspace,
              color,
              key: workspace.id,
              date,
            }}
          />
        ))}
    </>
  );
};
